export default __webpack_public_path__ + "static/media/locationIcon.62b69eec.svg";